import { formatMoney, getSizedImageUrl } from '//zigarrendepotdepot.com/cdn/shop/t/94/assets/theme.js?v=34606369793379638831792174063';

$(document).ready(function () {
  // MH 01.12.2023
  // MASKING THIRD LEVEL LINKS IN MEGA MENU
  var variants = document.querySelectorAll('[data-href]');
  for (let i = 0; i < variants.length; i++) {
    variants[i].addEventListener("click", function() {
      location.href = this.getAttribute('data-href');
    });
  }

  // MH 01.12.2023
  // MASKING VARIANT LINKS
  var variants = document.querySelectorAll('[data-variant-href]');
  for (let i = 0; i < variants.length; i++) {
    variants[i].addEventListener("click", function() {
      location.href = this.getAttribute('data-variant-href');
    });
  }


  $('.swiper-container').each(function (i, e) {
    var mySwiper = new Swiper($('.swiper-container')[i], {
      // Optional parameters
      loop: true,
      spaceBetween: 10,
      slidesPerView: 8,
      breakpoints: {
        320: {
          slidesPerView: 3
        },
        600: {
          slidesPerView: 5
        },
        768: {
          slidesPerView: 6
        },
        992: {
          slidesPerView: 7
        },
        1200: {
          slidesPerView: 8
        }
      },
      // If we need pagination
      pagination: {
        el: '.swiper-pagination'
      },
      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }
    });
  });
});


/*Hasaan @LatoriGMBH*/
class ProductConnector extends HTMLElement {
  constructor() {
    super();

    // Get references to the elements within the existing element
    this.spanElement = this.querySelector('[data-current-option]');
    this.aElements = this.querySelectorAll('a');

    if (!this.spanElement) {
      return;
    }

    // Capture the default text content
    this.defaultText = this.spanElement.textContent;

    // Add event listeners to the <a> elements
    this.aElements.forEach((a) => {
      a.addEventListener('mouseover', () => {
        // Change the textContent of the <span> element on hover
        this.spanElement.textContent = a.getAttribute('data-option');
      });

      a.addEventListener('mouseout', () => {
        // Reset the textContent of the <span> element to the default text
        this.spanElement.textContent = this.defaultText;
      });
    });
  }
}

// Register the custom element (if not already registered)
window.customElements.define('product-connector', ProductConnector);


class CountDownTimer extends HTMLElement {
  constructor() {
    super();

    const raw = (this.getAttribute('data-enddate') || '').trim();
    this.endTime = new Date(raw);
    this.initialHtml = this.innerHTML;
    this.lastRenderedHtml = '';

    // Fix: YYYY-MM-DD wird als UTC geparst -> in DE +1/+2h Versatz
    if (/^\d{4}-\d{2}-\d{2}$/.test(raw) && !isNaN(this.endTime)) {
      this.endTime = new Date(this.endTime.getTime() + this.endTime.getTimezoneOffset() * 60 * 1000);
    }

    this.isValidCountdown = raw !== '' && !isNaN(this.endTime);
  }

  connectedCallback() {
    if (!this.isValidCountdown) {
      return;
    }

    if (this.updateCountdown()) {
      CountDownTimer.activeTimers.add(this);
      CountDownTimer.startSharedCountdown();
    }
  }

  getTimeParts() {
    const difference = this.endTime - new Date();
    const safeDifference = Math.max(0, difference);
    const millisecondsInADay = 1000 * 60 * 60 * 24;
    const days = Math.floor(safeDifference / millisecondsInADay);
    const remainingMilliseconds = safeDifference % millisecondsInADay;
    const hours = Math.floor(remainingMilliseconds / (1000 * 60 * 60));
    const minutes = Math.floor((remainingMilliseconds % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((remainingMilliseconds % (1000 * 60)) / 1000);

    return {
      difference,
      days,
      hours,
      minutes,
      seconds
    };
  }

  getString(replaceText, timeParts) {
    replaceText = replaceText.replace(/\[dd\]/g, timeParts.days);
    replaceText = replaceText.replace(/\[hh\]/g, timeParts.hours);
    replaceText = replaceText.replace(/\[mm\]/g, timeParts.minutes);
    replaceText = replaceText.replace(/\[ss\]/g, timeParts.seconds);
    return replaceText;
  }

  updateCountdown() {
    const timeParts = this.getTimeParts();

    if (timeParts.difference <= 0) {
      this.expireCountdown();
      return false;
    }

    const nextHtml = this.getString(this.initialHtml, timeParts);

    if (nextHtml !== this.lastRenderedHtml) {
      this.innerHTML = nextHtml;
      this.lastRenderedHtml = nextHtml;
    }

    this.setAttribute('inited', true);
    return true;
  }

  expireCountdown() {
    this.innerHTML = '';
    this.lastRenderedHtml = '';

    // Check if the timer is inside a div with the class shopify-section--announcement-bar
    const announcementBar = this.closest('.shopify-section--announcement-bar');
    if (announcementBar) {
      announcementBar.style.display = 'none';
    }
    const uspBar = document.querySelector('.usp-bar-wrapper');
    if (uspBar) {
      uspBar.removeAttribute('hidden');
    }
  }

  disconnectedCallback() {
    CountDownTimer.activeTimers.delete(this);
    CountDownTimer.stopSharedCountdownIfIdle();
  }

  static startSharedCountdown() {
    if (CountDownTimer.countdownInterval) {
      return;
    }

    CountDownTimer.countdownInterval = setInterval(() => {
      CountDownTimer.activeTimers.forEach((timer) => {
        if (!timer.updateCountdown()) {
          CountDownTimer.activeTimers.delete(timer);
        }
      });

      CountDownTimer.stopSharedCountdownIfIdle();
    }, 1000);
  }

  static stopSharedCountdownIfIdle() {
    if (CountDownTimer.activeTimers.size === 0 && CountDownTimer.countdownInterval) {
      clearInterval(CountDownTimer.countdownInterval);
      CountDownTimer.countdownInterval = null;
    }
  }
}

// Define the custom element
CountDownTimer.activeTimers = new Set();
CountDownTimer.countdownInterval = null;
customElements.define('countdown-timer', CountDownTimer);


class CountDownTimerPrice extends HTMLElement {
constructor() {
  super();

  const raw = (this.getAttribute('data-enddate') || '').trim();
  this.endTime = new Date(raw);
  this.initialHtml = this.innerHTML;
  this.prefixText = (this.querySelector('.countdowntimer--price')?.textContent || 'Deal endet in').trim();
  this.enableProductPageBreakdown = this.getAttribute('data-product-page-breakdown') === 'true';
  const thresholdHoursRaw = this.getAttribute('data-hours-switch-threshold');
  const thresholdHoursParsed = Number.parseInt(thresholdHoursRaw, 10);
  this.hoursSwitchThreshold = Number.isFinite(thresholdHoursParsed) && thresholdHoursParsed > 0 ? thresholdHoursParsed : 24;

  // Fix: YYYY-MM-DD wird als UTC geparst -> in DE +1/+2h Versatz
  if (/^\d{4}-\d{2}-\d{2}$/.test(raw) && !isNaN(this.endTime)) {
    this.endTime = new Date(this.endTime.getTime() + this.endTime.getTimezoneOffset() * 60 * 1000);
  }

  if (raw !== '' && !isNaN(this.endTime)) {
    if (this.updateCountdown()) {
      this.startCountdown();
    }
  }
}


  getTimeParts() {
    const now = new Date();
    const difference = this.endTime - now;
    const safeDifference = Math.max(0, difference);
    const millisecondsInADay = 1000 * 60 * 60 * 24;
    const totalHours = Math.floor(safeDifference / (1000 * 60 * 60));
    const days = Math.floor(totalHours / 24);
    const remainingMilliseconds = safeDifference % millisecondsInADay;
    const hours = Math.floor(remainingMilliseconds / (1000 * 60 * 60));
    const minutes = Math.floor((remainingMilliseconds % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((remainingMilliseconds % (1000 * 60)) / 1000);

    return {
      difference,
      safeDifference,
      totalHours,
      days,
      hours,
      minutes,
      seconds
    };
  }

  shouldUseProductBreakdown() {
    return this.enableProductPageBreakdown;
  }

  renderDefaultCountdown(timeParts) {
    const millisecondsInADay = 1000 * 60 * 60 * 24;
    const daysinhours = Math.floor(timeParts.safeDifference / millisecondsInADay) * 24;
    const remainingMilliseconds = timeParts.safeDifference % millisecondsInADay;
    const hours = Math.floor(remainingMilliseconds / (1000 * 60 * 60)) + daysinhours;
    const minutes = String(timeParts.minutes).padStart(2, '0');
    const seconds = String(timeParts.seconds).padStart(2, '0');

    let replaceText = this.initialHtml;
    replaceText = replaceText.replace(/\[hh\]/g, hours);
    replaceText = replaceText.replace(/\[mm\]/g, minutes);
    replaceText = replaceText.replace(/\[ss\]/g, seconds);
    this.innerHTML = replaceText;
  }

  renderProductBreakdown(timeParts) {
    const daysLabel = timeParts.days === 1 ? 'Tag' : 'Tagen';

    const switchThresholdMs = this.hoursSwitchThreshold * 60 * 60 * 1000;

    if (timeParts.safeDifference > switchThresholdMs) {
      this.innerHTML = `
        <span class="countdowntimer--price">${this.prefixText} <span class="countdown-days-only">${timeParts.days} ${daysLabel}</span></span>
      `;
      return;
    }

    const hours = String(timeParts.totalHours).padStart(2, '0');
    const minutes = String(timeParts.minutes).padStart(2, '0');
    const seconds = String(timeParts.seconds).padStart(2, '0');

    this.innerHTML = `
      <span class="countdowntimer--price">${this.prefixText}</span>
      <span class="countdown-inline">
        <span class="countdown-clock">${hours}:${minutes}:${seconds}</span>
      </span>
    `;
  }

  updateCountdown() {
    const timeParts = this.getTimeParts();
    if (timeParts.difference <= 0) {
      this.innerHTML = '';
      return false;
    }

    if (this.shouldUseProductBreakdown()) {
      this.renderProductBreakdown(timeParts);
    } else {
      this.renderDefaultCountdown(timeParts);
    }

    this.setAttribute('inited', true);
    return true;
  }

  startCountdown() {
    this.countdownInterval = setInterval(() => {
      if (!this.updateCountdown()) {
        this.innerHTML = '';
        clearInterval(this.countdownInterval);        
        // Check if the timer is inside a div with the class shopify-section--announcement-bar
        const announcementBar = this.closest('.shopify-section--announcement-bar');
        if (announcementBar) {
          announcementBar.style.display = 'none';
        }
        const uspBar = document.querySelector('.usp-bar-wrapper');
        if (uspBar) {
          uspBar.removeAttribute('hidden');
        }
      }
    }, 1000);
  }

  disconnectedCallback() {
    // Stop the interval when the element is removed
    clearInterval(this.countdownInterval);
  }
}

// Define the custom element
customElements.define('countdown-timer-price', CountDownTimerPrice);

import { CartDrawer, CartNotificationDrawer } from "//zigarrendepotdepot.com/cdn/shop/t/94/assets/theme.js?v=34606369793379638831792174063";

function isPopupDrawerMode() {
  return window.themeVariables?.settings?.cartType === "popup_drawer";
}

function checkoutUrl() {
  return `${Shopify.routes.root}checkout`;
}

class CustomCartDrawer extends CartDrawer {
  constructor() {
    super(); // Call the constructor of the parent class
    // Add your event listener here
    this.init();
    //document.addEventListener("cart:ajax", () => {console.log('CART UPDATED VIA AJAX EVENT')});
  }

  init(){
    if (!isPopupDrawerMode()) {
      return;
    }

    this.checkoutButtons = Array.from(this.querySelectorAll('button[name="checkout"]'));
    this.checkoutButtons.forEach((checkoutButton) => {
      if (checkoutButton.dataset.inited === "true") {
        return;
      }

      checkoutButton.addEventListener('click', (e) => this.handleCartClick(e));
      checkoutButton.dataset.inited = "true";
    });

    this.userLoggedIn = JSON.parse(this.getAttribute('data-loggendin')); // TRUE FIELD
  }

  handleCartClick(event) {
    if (!isPopupDrawerMode()) {
      return;
    }

    // Your event handling logic here
    event.preventDefault();
    this.userLoggedIn = true; // with new Shopify login the login page is not needed, jump directly to checkout
    if(!this.userLoggedIn){
      window.location.href = '/account/login?return_url=%2Fcheckout';
    }else{
      window.location.href = checkoutUrl();
    }
  }
}

class CustomCartNotificationDrawer extends CartNotificationDrawer {
  constructor() {
    super(); // Call the constructor of the parent class

    if (!isPopupDrawerMode()) {
      return;
    }

    this.checkoutButton = this.shadowRoot.querySelector('button[type="submit"]');
    if (this.checkoutButton){
      this.checkoutButton.addEventListener('click', (e) => this.handleCartClick(e));
      this.userLoggedIn = JSON.parse(this.getAttribute('data-loggendin')); // TRUE FIELD
    }
  }

  handleCartClick(event) {
    if (!isPopupDrawerMode()) {
      return;
    }

    // Your event handling logic here
    event.preventDefault();
    this.userLoggedIn = true; // with new Shopify login the login page is not needed, jump directly to checkout
    if(!this.userLoggedIn){
      window.location.href = '/account/login?return_url=%2Fcheckout';
    }else{
      window.location.href = checkoutUrl();
    }
  }
}

class PopupCustomCartDrawer extends CustomCartDrawer {
  constructor() {
    super();
    this._onLeasingButtonClickListener = this._onLeasingButtonClick.bind(this);
    this._onLeasingDialogAfterShowListener = this._onLeasingDialogAfterShow.bind(this);
    this._onLeasingDialogAfterHideListener = this._onLeasingDialogAfterHide.bind(this);
    this._onLeasingSubmitIntentListener = this._onLeasingSubmitIntent.bind(this);
    this._onPopupDrawerAfterShowListener = this._onPopupDrawerAfterShow.bind(this);
    this._onPopupDrawerAfterHideListener = this._onPopupDrawerAfterHide.bind(this);
    this._onExplicitCloseIntentListener = this._onExplicitCloseIntent.bind(this);

    this._leasingCloseShouldReopenCart = false;
    this._leasingFlowIsActive = false;
    this._leasingSubmitTriggered = false;
    this._leasingOpenRequestedAt = 0;
    this._bodyScrollLocked = false;
    this._savedScrollY = 0;
    this._lastPopupToggleAt = 0;
    this._popupToggleDebounceMs = 450;
    this._suppressImmediateHideUntil = 0;
    this._popupImmediateHideGuardMs = 1200;
    this._allowForcedCloseUntil = 0;
  }

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('click', this._onLeasingButtonClickListener);
    this.addEventListener('dialog:after-show', this._onPopupDrawerAfterShowListener);
    this.addEventListener('dialog:after-hide', this._onPopupDrawerAfterHideListener);
    document.addEventListener('dialog:after-show', this._onLeasingDialogAfterShowListener);
    document.addEventListener('dialog:after-hide', this._onLeasingDialogAfterHideListener);
    document.addEventListener('click', this._onLeasingSubmitIntentListener, true);
    document.addEventListener('submit', this._onLeasingSubmitIntentListener, true);
    this.addEventListener('click', this._onExplicitCloseIntentListener, true);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('click', this._onLeasingButtonClickListener);
    this.removeEventListener('dialog:after-show', this._onPopupDrawerAfterShowListener);
    this.removeEventListener('dialog:after-hide', this._onPopupDrawerAfterHideListener);
    document.removeEventListener('dialog:after-show', this._onLeasingDialogAfterShowListener);
    document.removeEventListener('dialog:after-hide', this._onLeasingDialogAfterHideListener);
    document.removeEventListener('click', this._onLeasingSubmitIntentListener, true);
    document.removeEventListener('submit', this._onLeasingSubmitIntentListener, true);
    this.removeEventListener('click', this._onExplicitCloseIntentListener, true);
    this._unlockBodyScroll();
  }

  _isPopupDrawerCartType() {
    return window.themeVariables.settings.cartType === "popup_drawer";
  }

  _isPopupDrawerMobileViewport() {
    return window.matchMedia('(max-width: 640px)').matches;
  }

  _shouldBlockTransientClose() {
    return this._isPopupDrawerCartType() && this._isPopupDrawerMobileViewport() && Date.now() < this._suppressImmediateHideUntil;
  }

  _canBypassTransientClose() {
    return Date.now() < this._allowForcedCloseUntil;
  }

  removeAttribute(name) {
    if (name === 'open' && this._shouldBlockTransientClose() && !this._canBypassTransientClose()) {
      return;
    }

    const result = super.removeAttribute(name);

    if (name === 'open') {
      this._allowForcedCloseUntil = 0;
    }

    return result;
  }

  _togglePopupDrawerFromTrigger(event) {
    if (!this._isPopupDrawerCartType()) {
      super._onToggleClicked(event);
      return;
    }

    event?.preventDefault?.();
    const isMobileViewport = this._isPopupDrawerMobileViewport();

    if (isMobileViewport && this.open) {
      return;
    }

    const now = Date.now();
    if (now - this._lastPopupToggleAt < this._popupToggleDebounceMs) {
      return;
    }

    this._lastPopupToggleAt = now;

    if (isMobileViewport) {
      this.show();
      return;
    }

    this.open ? this.hide() : this.show();
  }

  _onToggleClicked(event) {
    this._togglePopupDrawerFromTrigger(event);
  }

  show(animate = true) {
    if (this._isPopupDrawerCartType() && this._isPopupDrawerMobileViewport()) {
      this._suppressImmediateHideUntil = Date.now() + this._popupImmediateHideGuardMs;
      animate = false;
    } else {
      this._suppressImmediateHideUntil = 0;
    }

    return super.show(animate);
  }

  hide() {
    if (this._shouldBlockTransientClose() && !this._canBypassTransientClose()) {
      return Promise.resolve();
    }

    return super.hide();
  }

  _allowOutsideClick(event) {
    const target = event?.target;

    if (target instanceof Element && target.closest(`[aria-controls="${this.id}"]`)) {
      return false;
    }

    if (this._shouldBlockTransientClose()) {
      return false;
    }

    return super._allowOutsideClick(event);
  }

  _onExplicitCloseIntent(event) {
    if (!this._isPopupDrawerCartType()) {
      return;
    }

    const path = typeof event.composedPath === 'function' ? event.composedPath() : [];

    const isExplicitCloseIntent = path.some((node) => {
      if (!(node instanceof Element)) {
        return false;
      }

      const part = node.getAttribute('part') || '';
      const partTokens = part ? part.split(/\s+/) : [];

      if (partTokens.includes('close-button') || partTokens.includes('outside-close-button')) {
        return true;
      }

      if (node.getAttribute('is') === 'close-button') {
        return true;
      }

      return !!node.closest?.('[data-action="close-drawer"]');
    });

    if (isExplicitCloseIntent) {
      this._allowForcedCloseUntil = Date.now() + 500;
    }
  }

  _onLeasingButtonClick(event) {
    if (!this._isPopupDrawerCartType()) {
      return;
    }

    const target = event.target;
    if (!(target instanceof Element)) {
      return;
    }

    const leasingButton = target.closest('button[aria-controls="LeasingDrawer"]');
    if (!leasingButton || !this.contains(leasingButton)) {
      return;
    }

    this._leasingCloseShouldReopenCart = true;
    this._leasingFlowIsActive = false;
    this._leasingSubmitTriggered = false;
    this._leasingOpenRequestedAt = Date.now();
  }

  _onPopupDrawerAfterShow(event) {
    if (event.target !== this || !this._shouldLockBodyScroll()) {
      return;
    }

    this._lockBodyScroll();
  }

  _onPopupDrawerAfterHide(event) {
    if (event.target !== this) {
      return;
    }

    this._unlockBodyScroll();
  }

  _shouldLockBodyScroll() {
    return this._isPopupDrawerCartType() && window.matchMedia('(max-width: 640px)').matches;
  }

  _lockBodyScroll() {
    if (this._bodyScrollLocked) {
      return;
    }

    this._savedScrollY = window.scrollY || window.pageYOffset || 0;
    document.body.classList.add('popup-drawer-scroll-locked');
    document.body.style.position = 'fixed';
    document.body.style.top = `-${this._savedScrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
    this._bodyScrollLocked = true;
  }

  _unlockBodyScroll() {
    if (!this._bodyScrollLocked) {
      return;
    }

    const restoredScrollY = this._savedScrollY;

    document.body.classList.remove('popup-drawer-scroll-locked');
    document.body.style.removeProperty('position');
    document.body.style.removeProperty('top');
    document.body.style.removeProperty('left');
    document.body.style.removeProperty('right');
    document.body.style.removeProperty('width');
    document.body.style.removeProperty('overflow');

    this._bodyScrollLocked = false;
    this._savedScrollY = 0;

    window.scrollTo(0, restoredScrollY);
  }

  _onLeasingDialogAfterShow(event) {
    if (!this._isPopupDrawerCartType()) {
      return;
    }

    const dialog = event.target;
    if (!(dialog instanceof Element) || dialog.id !== 'LeasingDrawer') {
      return;
    }

    if (!this._leasingCloseShouldReopenCart) {
      return;
    }

    if (!this._leasingOpenRequestedAt || (Date.now() - this._leasingOpenRequestedAt) > 5000) {
      this._leasingCloseShouldReopenCart = false;
      this._leasingOpenRequestedAt = 0;
      return;
    }

    this._leasingFlowIsActive = true;
    this._leasingOpenRequestedAt = 0;

    if (this.open) {
      this.hide();
    }
  }

  _onLeasingSubmitIntent(event) {
    if (!this._isPopupDrawerCartType()) {
      return;
    }

    let isLeasingSubmitIntent = false;

    if (event.type === 'click') {
      const target = event.target;

      if (!(target instanceof Element)) {
        return;
      }

      const submitButton = target.closest('button[name="submitLeasingForm"], #LeasingDrawer button[type="submit"]');
      isLeasingSubmitIntent = !!submitButton && !!submitButton.closest('#LeasingDrawer');
    } else if (event.type === 'submit') {
      const target = event.target;
      isLeasingSubmitIntent = target instanceof Element && (target.id === 'leasingForm' || !!target.closest('#LeasingDrawer'));
    }

    if (!isLeasingSubmitIntent) {
      return;
    }

    this._leasingSubmitTriggered = true;
    this._leasingCloseShouldReopenCart = false;
    this._leasingOpenRequestedAt = 0;
  }

  _onLeasingDialogAfterHide(event) {
    if (!this._isPopupDrawerCartType()) {
      return;
    }

    const dialog = event.target;
    if (!(dialog instanceof Element) || dialog.id !== 'LeasingDrawer') {
      return;
    }

    const shouldReopenCartDrawer = this._leasingFlowIsActive && this._leasingCloseShouldReopenCart && !this._leasingSubmitTriggered;

    this._leasingCloseShouldReopenCart = false;
    this._leasingFlowIsActive = false;
    this._leasingSubmitTriggered = false;
    this._leasingOpenRequestedAt = 0;

    if (shouldReopenCartDrawer) {
      this.show();
    }
  }

  _onVariantAdded(event) {
    document.dispatchEvent(new Event('cart:ajax'));
    if (window.themeVariables.settings.cartType !== "popup_drawer" || event.detail?.blockCartDrawerOpening) {
      return;
    }
  }

  async _onCartChanged(event) {
    if (!this._isPopupDrawerCartType()) {
      await super._onCartChanged(event);
      this.init();
      return;
    }

    const sectionMarkup = this._getPopupDrawerSectionMarkup(event?.detail?.cart?.sections);

    if (sectionMarkup) {
      const parsedSection = new DOMParser().parseFromString(sectionMarkup, "text/html");
      const updatedDrawer = parsedSection.querySelector("#popup-cart-drawer") || parsedSection.querySelector(".popup-cart-drawer");
      const currentMobileTop = this.querySelector(".popup-cart-drawer__mobile-top");
      const updatedMobileTop = updatedDrawer?.querySelector(".popup-cart-drawer__mobile-top");

      if (currentMobileTop && updatedMobileTop) {
        currentMobileTop.replaceWith(updatedMobileTop.cloneNode(true));
      }
    }

    await super._onCartChanged(event);
    this.init();
  }

  _getPopupDrawerSectionMarkup(sections) {
    if (!sections || typeof sections !== "object") {
      return "";
    }

    if (typeof sections["popup-cart-drawer"] === "string") {
      return sections["popup-cart-drawer"];
    }

    for (const sectionMarkup of Object.values(sections)) {
      if (typeof sectionMarkup === "string" && sectionMarkup.includes('id="popup-cart-drawer"')) {
        return sectionMarkup;
      }
    }

    return "";
  }
}

class PopupCustomCartNotificationDrawer extends CustomCartNotificationDrawer {
  constructor() {
    super();
    this._onViewCartClickListener = this._onViewCartClick.bind(this);
    this._onCheckoutClickListener = this._onCheckoutClick.bind(this);
    this._onCheckoutSubmitListener = this._onCheckoutSubmit.bind(this);
  }

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('click', this._onViewCartClickListener);
    this.addEventListener('click', this._onCheckoutClickListener, true);
    this.addEventListener('submit', this._onCheckoutSubmitListener, true);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('click', this._onViewCartClickListener);
    this.removeEventListener('click', this._onCheckoutClickListener, true);
    this.removeEventListener('submit', this._onCheckoutSubmitListener, true);
  }

  _isPopupDrawerMode() {
    return window.themeVariables.settings.cartType === "popup_drawer";
  }

  _onViewCartClick(event) {
    if (!this._isPopupDrawerMode()) {
      return;
    }

    const target = event.target;
    if (!(target instanceof Element)) {
      return;
    }

    const viewCartButton = target.closest('.buy-buttons--compact [aria-controls], .buy-buttons--compact a[href]');
    if (!viewCartButton || !this.contains(viewCartButton)) {
      return;
    }

    const targetDrawerId = viewCartButton.getAttribute('aria-controls') || 'popup-cart-drawer';
    const popupCartDrawer = document.getElementById(targetDrawerId);
    if (!popupCartDrawer?.show) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();

    this.addEventListener('dialog:after-hide', () => popupCartDrawer.show?.(), { once: true });
    this.hide();
  }

  _onCheckoutClick(event) {
    if (!this._isPopupDrawerMode()) {
      return;
    }

    const target = event.target;
    if (!(target instanceof Element)) {
      return;
    }

    const checkoutButton = target.closest('.buy-buttons--compact button[name="checkout"]');
    if (!checkoutButton || !this.contains(checkoutButton)) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();
    window.location.href = checkoutUrl();
  }

  _onCheckoutSubmit(event) {
    if (!this._isPopupDrawerMode()) {
      return;
    }

    const submitForm = event.target;
    if (!(submitForm instanceof HTMLFormElement) || !submitForm.matches('.buy-buttons--compact') || !this.contains(submitForm)) {
      return;
    }

    const submitter = event.submitter;
    const isCheckoutSubmit =
      (submitter instanceof Element && submitter.matches('button[name="checkout"]'))
      || !!submitForm.querySelector('button[name="checkout"]');

    if (!isCheckoutSubmit) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();
    window.location.href = checkoutUrl();
  }

  _onVariantAdded(event) {
    if (!this._isPopupDrawerMode() || event.detail?.blockCartDrawerOpening) {
      return;
    }

    const tempContent = document.createElement("div");
    tempContent.innerHTML = event.detail.cart["sections"]["variant-added"];
    const sectionRoot = tempContent.querySelector(".shopify-section");

    if (sectionRoot) {
      this.replaceChildren(...sectionRoot.children);
    } else {
      this.replaceChildren(...tempContent.children);
    }

    this.show();
  }

  _onMultipleVariantsAdded(event) {
    if (!this._isPopupDrawerMode() || event.detail?.blockCartDrawerOpening) {
      return;
    }

    const tempContent = document.createElement("div");
    tempContent.innerHTML = event.detail.cart["sections"]["variant-added"];
    const sectionRoot = tempContent.querySelector(".shopify-section");

    if (sectionRoot) {
      this.replaceChildren(...sectionRoot.children);
    } else {
      this.replaceChildren(...tempContent.children);
    }

    this.querySelector('.quick-buy-drawer__variants').innerHTML = event.detail.variantItems.join('');
    this.show();
  }
}

// cart/shipping_rates.json stores the (dummy) estimate zip on the real cart, which then
// pre-fills the customer's checkout. We clear it right after each estimate by overwriting
// the cart's selected delivery address with an empty one via the Storefront API. The AJAX
// cart token doubles as the Storefront cart id (gid://shopify/Cart/<token>).
const STOREFRONT_CLEAR_ADDRESS_MUTATION = `
  mutation LLClearShippingAddress($cartId: ID!, $addresses: [CartSelectableAddressInput!]!) {
    cartDeliveryAddressesAdd(cartId: $cartId, addresses: $addresses) {
      userErrors { field message }
    }
  }
`;

class PopupCartShippingRate extends HTMLElement {
  constructor() {
    super();
    this._onCartChangedListener = this._refreshRate.bind(this);
    this._requestCounter = 0;
  }

  connectedCallback() {
    if (window.themeVariables?.settings?.cartType !== "popup_drawer") {
      return;
    }

    document.addEventListener("cart:change", this._onCartChangedListener);
    document.addEventListener("cart:refresh", this._onCartChangedListener);
    this._refreshRate();
  }

  disconnectedCallback() {
    document.removeEventListener("cart:change", this._onCartChangedListener);
    document.removeEventListener("cart:refresh", this._onCartChangedListener);
  }

  async _refreshRate() {
    if (window.themeVariables?.settings?.cartType !== "popup_drawer") {
      return;
    }

    const requestId = ++this._requestCounter;
    const fallbackText = this.dataset.fallbackText || "Wird berechnet";
    const zip = (this.dataset.zip || "59929").trim();
    const country = (this.dataset.country || "Germany").trim();
    const shouldApplyGrandTotal = this.dataset.applyGrandTotal === "true";

    if (!zip || !country) {
      this._setText(fallbackText, false);
      if (shouldApplyGrandTotal) {
        this._resetGrandTotal();
      }
      return;
    }

    this.setAttribute("aria-busy", "true");

    try {
      const query = new URLSearchParams();
      query.set("shipping_address[zip]", zip);
      query.set("shipping_address[country]", country);

      const response = await fetch(`${Shopify.routes.root}cart/shipping_rates.json?${query.toString()}`, {
        headers: { Accept: "application/json" }
      });

      if (!response.ok) {
        throw new Error("shipping_rates_failed");
      }

      const payload = await response.json();

      if (payload?.error) {
        this._setText(fallbackText, false);
        if (shouldApplyGrandTotal) {
          this._resetGrandTotal();
        }
        return;
      }

      const shippingRates = Array.isArray(payload?.shipping_rates) ? payload.shipping_rates : [];

      if (requestId !== this._requestCounter) {
        return;
      }

      if (shippingRates.length === 0) {
        this._setText(fallbackText, false);
        if (shouldApplyGrandTotal) {
          this._resetGrandTotal();
        }
        return;
      }

      const minRate = shippingRates.reduce((currentMin, shippingRate) => {
        const parsedRate = this._parseRate(shippingRate?.price);
        return Number.isFinite(parsedRate) && parsedRate < currentMin ? parsedRate : currentMin;
      }, Number.POSITIVE_INFINITY);

      if (!Number.isFinite(minRate)) {
        this._setText(fallbackText, false);
        if (shouldApplyGrandTotal) {
          this._resetGrandTotal();
        }
        return;
      }

      if (minRate <= 0) {
        this._setText(this.dataset.freeText || "Kostenlos", true);
        if (shouldApplyGrandTotal) {
          this._updateGrandTotal(0);
        }
      } else {
        const minRateCents = Math.round(minRate * 100);
        const altRateCents = Number.parseInt(this.dataset.altRateCents || "", 10);
        const useAltRateText = Number.isFinite(altRateCents) && minRateCents === altRateCents && this.dataset.altRateText;

        this._setText(useAltRateText ? this.dataset.altRateText : this._formatEuro(minRate), false, useAltRateText);
        if (shouldApplyGrandTotal) {
          this._updateGrandTotal(minRateCents);
        }
      }
    } catch (error) {
      if (requestId === this._requestCounter) {
        this._setText(fallbackText, false);
        if (shouldApplyGrandTotal) {
          this._resetGrandTotal();
        }
      }
    } finally {
      if (requestId === this._requestCounter) {
        this.removeAttribute("aria-busy");
        // Remove the dummy estimate zip that shipping_rates.json just stored on the cart,
        // so it never pre-fills the checkout. Best-effort, non-blocking.
        this._clearLeakedShippingAddress();
      }
    }
  }

  async _clearLeakedShippingAddress() {
    const token = (this.dataset.storefrontToken || "").trim();
    if (!token) {
      return;
    }

    const version = (this.dataset.storefrontApiVersion || "2025-07").trim();

    try {
      const cart = await (await fetch(`${Shopify.routes.root}cart.js`, { headers: { Accept: "application/json" } })).json();
      const cartToken = cart?.token;
      if (!cartToken) {
        return;
      }

      await fetch(`${window.location.origin}/api/${version}/graphql.json`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-Shopify-Storefront-Access-Token": token
        },
        body: JSON.stringify({
          query: STOREFRONT_CLEAR_ADDRESS_MUTATION,
          variables: {
            cartId: `gid://shopify/Cart/${cartToken}`,
            addresses: [
              { selected: true, address: { deliveryAddress: { countryCode: "DE", zip: "" } } }
            ]
          }
        })
      });
    } catch (error) {
      // Best-effort — if clearing fails the estimate still worked; ignore.
    }
  }

  _parseRate(value) {
    const normalizedValue = String(value ?? "").trim().replace(",", ".");
    const parsedValue = Number.parseFloat(normalizedValue);
    return Number.isFinite(parsedValue) ? parsedValue : Number.NaN;
  }

  _formatEuro(value) {
    const formattedValue = new Intl.NumberFormat("de-DE", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(value);

    return `${formattedValue} €`;
  }

  _setText(text, isFree, isAltRate = false) {
    this.textContent = text;
    this.classList.toggle("is-free", !!isFree);
    this.classList.toggle("is-alt-rate", !!isAltRate);
  }

  _updateGrandTotal(shippingCents) {
    this._getGrandTotalTargets().forEach((target) => {
      const baseSubtotalCents = Number.parseInt(target.dataset.baseSubtotalCents || "", 10);

      if (!Number.isFinite(baseSubtotalCents)) {
        return;
      }

      const grandTotalCents = baseSubtotalCents + shippingCents;
      target.textContent = this._formatEuro(grandTotalCents / 100);
    });
  }

  _resetGrandTotal() {
    this._updateGrandTotal(0);
  }

  _getGrandTotalTargets() {
    const drawerRoot = this.closest(".popup-cart-drawer");

    if (!drawerRoot) {
      return [];
    }

    return Array.from(drawerRoot.querySelectorAll(".popup-cart-drawer__total-amount[data-base-subtotal-cents]"));
  }
}

if (!window.customElements.get("cart-drawer-x")) {
  window.customElements.define("cart-drawer-x", CustomCartDrawer);
}

if (!window.customElements.get("cart-notification-drawer-x")) {
  window.customElements.define("cart-notification-drawer-x", CustomCartNotificationDrawer);
}

if (!window.customElements.get("popup-cart-drawer-x")) {
  window.customElements.define("popup-cart-drawer-x", PopupCustomCartDrawer);
}

if (!window.customElements.get("popup-cart-notification-drawer-x")) {
  window.customElements.define("popup-cart-notification-drawer-x", PopupCustomCartNotificationDrawer);
}

if (!window.customElements.get("popup-cart-shipping-rate")) {
  window.customElements.define("popup-cart-shipping-rate", PopupCartShippingRate);
}


class InfinityScroll extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback(){
    this.init();
    this.scrollListener = () => this.handleScroll(); // Store the listener function reference
    document.addEventListener('scroll', this.scrollListener);

  }

  disconnectedCallback(){
    document.removeEventListener('scroll', this.scrollListener);
  }

  init(){
    this.loadMoreButton = this.querySelector('button');
    this.current = parseInt(this.getAttribute('data-current'));
    this.pages = JSON.parse(this.getAttribute('data-pages'));
    this.endPage = this.pages.slice(-1);
    this.pageData = {};
    this.loadingSoldOut = false;
    this.loadMoreButton.addEventListener('click', () => this.getProducts());
    this.scrollLoad = false;
    this.collectionContainer = document.querySelector('.collection product-list');
    this.language = JSON.parse(this.getAttribute('data-lang'));
  }

  handleScroll(){
    if(this.scrollLoad){
      if (this.isElementInViewport(this)) {
        this.getProducts();
        this.scrollLoad = false;
      }
    }
  }

  async getProducts() {
    this.loadMoreButton.textContent = this.language.loading;
    let current = this.current;
    let loadNumbers = this.pages.slice(0, 1);
    this.pages = this.pages.filter((_, i) => i >= 1);

    if (this.pages.length <= 0){
      this.setAttribute('hidden', true);
    }

    let tempDiv = document.createElement('div');
    let searchParams = new URL(window.location.href).searchParams;

    const queryParamsObject = {};
    for (const [key, value] of searchParams) {
      queryParamsObject[key] = value;
    }

    let productItemsContainer = document.createElement('div');

    //It was initially an array of 10 pages because i misunderstood the task
    //But ill leave it cuz it works and also can be used with await if wished to expand its function

    for (const i of loadNumbers){
      this.current++;
      queryParamsObject.page = this.current;
      let fetchURl = this.getURLBase() + '?' + this.createQueryString(queryParamsObject);
      let data = await this.getCollectionData(fetchURl);
      let productItems = data.targets.querySelectorAll('product-card');

      productItems.forEach((item) => {
        this.collectionContainer.append(item);
        if(item.hasAttribute('sold-out')){
          this.scrollLoad = false;
          this.loadMoreButton.textContent = this.language.load_more;
          this.loadingSoldOut = true;

        }else{
          this.scrollLoad = true;
        }
      })

      if (this.current >= this.endPage){
        this.setAttribute('hidden', true);
        return;
      }
    }

    //Keeping this in case the logic reverts
    if (this.current % 10 === 0) {
      this.scrollLoad = false;
      this.loadMoreButton.textContent = this.language.load_more;
    }else{
      this.scrollLoad = true;
    }
  }
  async getCollectionData(fetchURL) {
    try {
      const response = await fetch(fetchURL);
      const html = await response.text();
      let tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;
      let targets = tempDiv.querySelector('[data-infinity-target]');
      return {
        targets: targets
      };
    } catch (error) {
      console.error('Error fetching data:', error);
      return {
        targets: null
      };
    }
  }

  getURLBase(){
    return location.protocol + '//' + location.host + location.pathname;
  }

  createQueryString(params) {
    const queryString = Object.keys(params)
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
            .join('&');
    return queryString;
  }

  isElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }
}
window.customElements.define("infinity-scroll", InfinityScroll);

import { Drawer } from "//zigarrendepotdepot.com/cdn/shop/t/94/assets/theme.js?v=34606369793379638831792174063";

class LocationDrawer extends Drawer {
  constructor() {
    super();
    this.data = JSON.parse(this.getAttribute('data-traffic'));
    this.times = {}
    this.locationsButton = document.querySelector(`[aria-controls="${this.getAttribute('id')}"]`);
    this.current = JSON.parse(this.getAttribute('data-current'));
    this.init(this.getAttribute("data-id"));

    if(localStorage.getItem('selectedLocation')){
      this.setButtonContent(localStorage.getItem('selectedLocation'))
    }

    document.addEventListener('variant:change', this.handleVariantChange.bind(this));
  }


  addEventListeners(){
      this.chooseLocationButtons.forEach((button) => {
        button.addEventListener('click', this.handleLocationChange.bind(this))

      })
  }

  handleLocationChange(event){
    let locationsID = event.target.closest('[aria-controls]').getAttribute('aria-controls');
    if(locationsID){
      if(this.locationsButton){
          this.locationsButton.closest('form').querySelector('buy-buttons button').click();
      }
      localStorage.setItem('selectedLocation', locationsID)
      this.setButtonContent(locationsID);
    }
  }


  setButtonContent(locationsId){
    //this.locationsButton.querySelector('div').textContent = `${this.querySelector(`[data-location-time="${locationsId}"]`).innerText} | ${this.querySelector(`[data-location-time="${locationsId}"]`).closest('[data-container]').querySelector('[data-heading]').innerText}`;
  }

  handleVariantChange(event){
    let id = event.detail.variant.id.toString();
    let foundVariant = this.data.variants.find(v => v.id === id);
    this.current = foundVariant["stock"];
    this.removeAttribute('data-inited');
    //Initialize the Variant Max Times, as they could be different form the previous variant:
    this.times = {}
    
    this.init(id, localStorage.getItem('selectedLocation'));
  }


  init(id, optionalLocationID){
    let gid = id;
    let foundVariant = this.data.variants.find(v => v.id === id);

    // Aktuelle Stunde in deutscher Zeit - einmal pro init() statt einmal pro Standort.
    // toLocaleString mit timeZone ist teuer und das Ergebnis ist für alle Standorte
    // identisch. Vorher lief das bei jedem Variantenwechsel 10x (= Anzahl Standorte).
    const hours = LocationDrawer._currentHourInGermany();

    this.querySelectorAll('[data-location-time]').forEach((locationItem) => {

      let locationGid = locationItem.getAttribute('data-location-time');
      let time = this.calcPickupDates(this.current,locationGid);

      let spanElement = locationItem.querySelector('span');

      //edit time if its already 5 hours befpre delivers:
      if(time == 0 && hours >= 10){
        time = time+1;
      }
      
      let timeString;

      //time = 8; // Set Delivery Time to 8 Days - Für Fabian: Diese Zeilen löschen oder auskommentieren, wenn du die Funktionalität nicht brauchst

      if (time == 0) {
        spanElement.textContent = this.getAttribute('data-sameday');
        timeString = this.getAttribute('data-sameday');
        spanElement.classList.remove('text-warning');
        spanElement.classList.add('text-success');
      } else if (time == 1) {
        spanElement.textContent = this.getAttribute('data-xday').replace("[count]", time);
        timeString = this.getAttribute('data-xday').replace("[count]", time);
        spanElement.classList.remove('text-warning');
        spanElement.classList.add('text-success');
      } else {
        spanElement.textContent = this.getAttribute('data-xdays').replace("[count]", time);
        timeString = this.getAttribute('data-xdays').replace("[count]", time);
        spanElement.classList.remove('text-warning');
        spanElement.classList.add('text-success');
      }

      if(!foundVariant.available){
        spanElement.textContent = this.getAttribute('data-soldout');
        timeString = this.getAttribute('data-soldout');
        spanElement.classList.add('text-warning');
        spanElement.classList.remove('text-success');       
      }

      if(locationGid === optionalLocationID){
          //this.locationsButton.querySelector('div').textContent = `${timeString} | ${this.querySelector(`[data-location-time="${optionalLocationID}"]`).closest('[data-container]').querySelector('[data-heading]').textContent}`;
      }

    })

    this.querySelectorAll('[data-location-stock]').forEach((locationItem) => {
      locationItem.classList.remove('text-error', 'text-warning', 'text-success');
    
      let locationGid = locationItem.getAttribute('data-location-stock');
      let stockAmount = this.current[locationGid];
    
      let spanElement = locationItem.querySelector('span');
      let dotElement = locationItem.querySelector('.pulse_dot');
    
      if (stockAmount <= 0) {
        spanElement.textContent = this.getAttribute('data-unavailable');
        spanElement.classList.add('text-warning');
        dotElement.style.setProperty("--dot-color", "var(--almostsoldout)");
      } else if (stockAmount > 0 && stockAmount <= 3) {
        spanElement.textContent = this.getAttribute('data-lowstock');
        spanElement.classList.add('text-success');
        dotElement.style.setProperty("--dot-color", "var(--available)");
      } else if (stockAmount > 4) {
        spanElement.textContent = this.getAttribute('data-available');
        spanElement.classList.add('text-success');
        dotElement.style.setProperty("--dot-color", "var(--available)");
      }
    });


    if(!this.getAttribute('data-inited')){
      this.chooseLocationButtons = this.querySelectorAll('[data-chose-location]');
      this.addEventListeners();
      this.setAttribute('data-inited', true);
    }
  }


  /**
   * Aktuelle Stunde (0-23) in deutscher Zeit.
   *
   * Der Intl-Formatter wird einmalig angelegt und wiederverwendet - ihn zu
   * erzeugen ist der teure Teil. Ersetzt das frühere
   *   new Date(new Date().toLocaleString("en-US", {timeZone: "Europe/Berlin"})).getHours()
   * das zusätzlich noch einen formatierten String zurückparsen musste.
   */
  static _currentHourInGermany() {
    if (!LocationDrawer._hourFormatter) {
      LocationDrawer._hourFormatter = new Intl.DateTimeFormat('en-US', {
        timeZone: 'Europe/Berlin',
        hour: 'numeric',
        hourCycle: 'h23'
      });
    }

    return parseInt(LocationDrawer._hourFormatter.format(new Date()), 10);
  }


  calcPickupDates(metafieldObj, selectedLocation) {
    let maxDeliveryTime = 0;
    let locations = metafieldObj;
    let realQty = 1;
    let currentStock = metafieldObj;
        let tempTime = 2;
    
        switch (selectedLocation) {
          case '87280353589': //Zentrallager Neumann -> Ignore
            break;
          case '104355135797': //Zentrallager LL -> Ignore
            break;
          case '114932416821': //Liquid Life Showroom Brilon -> Ignore
            break;
          case '117396832565': //Ready2Ride -> Ignore
            break;
          case '87280288053': //Store Brilon / LL Brilon
            //If Store Brilon and ZL Neumann and ZL LL have enough Stock: Sameday
            if((currentStock['87280288053'] + currentStock['87280353589'] + currentStock['104355135797'] + currentStock['114932416821'] + (currentStock['117396832565'] || 0)) >= realQty){
              //console.log('neumann stock', tempTime);
            }else{
              //If Neumann Brilon (STORE!) has Stock, waiting Day is 1
              if(currentStock['86341058869'] >= realQty){
                tempTime = 2;
              }else{
                tempTime = 5;
              }
            }
          break; 
          
          case '86341058869': //Neumann Brilon
          if((currentStock['86341058869']) >= realQty){
          }
          else{
            //IF Store Brilon has and/or Zentrallager Neumann and Zentrallager LL has Stock
            if((currentStock['87280288053'] + currentStock['87280353589'] + currentStock['104355135797'] + currentStock['114932416821']) >= realQty){
              tempTime = 2;
            }else{
              tempTime = 5;
            }
          }
          break;
          
          case '106004807989': //LL Lippstadt
            if(currentStock['106004807989'] >= realQty){
              //Bielefeld has Stock, nothing Changes
            }else{
              tempTime = 5;
            }
            break;

          case '87280484661': // Bielefeld
            if(currentStock['87280484661'] >= realQty){
              //Bielefeld has Stock, nothing Changes
            }else{
              tempTime = 5;
            }
            break;
          
          case '87280451893': // Cube Store Paderborn
          if(currentStock['87280451893'] >= realQty){
            //Bielefeld has Stock, nothing Changes
          }else{
            tempTime = 5;
          }
          break;
          default: 47 
        }    
        if (this.times[selectedLocation] === undefined || this.times[selectedLocation] < tempTime) {
          this.times[selectedLocation] = tempTime;
        }
    return this.times[selectedLocation];
  }

  }


window.customElements.define("x-drawer-location", LocationDrawer);


import { VariantPicker } from "//zigarrendepotdepot.com/cdn/shop/t/94/assets/theme.js?v=34606369793379638831792174063";
class TMVariantPicker extends VariantPicker {
  constructor() {
    super();
    this.data = JSON.parse(this.querySelector('[data-traffic-json]').innerHTML);
    this.maxOptions = this.getAttribute('data-maxoptions');
    this.current = this.getAttribute('data-current-variant');
    this.pickerDrawer = this.querySelector('x-drawer');
    if (this.pickerDrawer) {
      this.drawerSelector = this.pickerDrawer.querySelector('.variant-picker__option-values');
    } else {
      this.drawerSelector = null;
    }
    this.init();
    document.addEventListener('variant:change', this.handleVariantChange.bind(this));
  }

  hasSubArray(master, sub) {
    return sub.every((item => value => item = master.indexOf(value, item) + 1)(0));
  }

  handleVariantChange(event) {
    if (event.detail?.variant?.id) {
      this.setColor(event.detail.variant.id.toString());
    }
  }

  init() {
    this.setColor(this.current);
  }

  setColor(id) { 
    if (this.drawerSelector) {
        this.drawerSelector.innerHTML = '';
      
        const otherSizes = [
          "4", "4.0", "4.5",
          "5", "5.0", "5.5",
          "6", "6.0", "6.5",
          "7", "7.0", "7.5",
          "8", "8.0", "8.5",
          "9", "9.0", "9.5",
          "10", "10.0", "10.5",
          "11", "11.0", "11.5",
          "12", "12.0", "12.5",
          "22", "22.0", "22.5",
          "23", "23.0", "23.5",
          "24", "24.0", "24.5",
          "25", "25.0", "25.5",
          "26", "26.0", "26.5",
          "27", "27.0", "27.5",
          "28", "28.0", "28.5",
          "29", "29.0", "29.5",
          "30", "30.0", "30.5",
          "31", "31.0", "31.5",
          "32", "32.0", "32.5",
          "33", "33.0", "33.5",
          "34", "34.0", "34.5",
          "35", "35.0", "35.5",
          "36", "36.0", "36 2/3", "36.5",
          "37", "37.0", "37 1/3", "37.5",
          "38", "38.0", "38 2/3", "38.5",
          "39", "39.0", "39 1/3", "39.5",
          "40", "40.0", "40 1/3", "40.5", "40 2/3",
          "41", "41.0", "41 1/3", "41.5",
          "42", "42.0", "42 1/3", "42.5", "42 1/2", "42 2/3",
          "43", "43.0", "43 1/3", "43.5", "43 1/2",
          "44", "44.0", "44 1/2", "44.5", "44 2/3",
          "45", "45.0", "45 1/3", "45.5",
          "46", "46.0", "46 2/3", "46.5",
          "47", "47.0", "47 1/3", "47.5",
          "48", "48.0", "48.5",
          "49", "49.0", "49 1/3", "49.5",
          "50", "50.0", "50.5", "50 2/3"
        ];
        
        const helmetSizes = [
          "46-51", "47-48", "48-52", "49-50", "49-53", "49-54", "49-55", "50-54", "50-55", "50-56", "50-57",
          "51-52", "51-53", "51-54", "51-55", "51-56", "51-57", "52-54", "52-55", "52-56", "52-57", "52-58",
          "53-54", "53-55", "53-56", "53-60", "54-56", "54-58", "54-59", "54-60", "54-61", "55-56", "55-57",
          "55-58", "55-59", "56-58", "56-59", "56-60", "56-61", "56-62", "57-58", "57-59", "57-61", "57-62",
          "58-59", "58-60", "58-61", "58-62", "58-63", "59-60", "59-61", "59-62", "59-63", "59-64", "60-61",
          "60-62", "60-63", "60-64", "61-62", "61-63", "61-65", "62-63", "63-64", "63-65"
        ];
        
        const clothingSizes = [
          'XXS', '2XS', 'XS', 'XS | 27.5"', 'S', 'S | 27.5"', 'M', 'M | 29"', 'M/L', 'ML', 'ML | 29"','L', 'L | 29"', 'XL', 'XL | 29"', 'XXL', '2XL', 'XXL | 29"', 'XXXL', '3XL', '4XL', 'XXXXL', '5XL', 'XXXXXL', '6XL'
        ];
        
        // Reihenfolge-Tabelle einmalig aufbauen und für alle weiteren Aufrufe behalten.
        // Vorher wurde in der Sortierung 4x pro Vergleich indexOf() über 222 Einträge
        // gelaufen - bei ~30 Varianten sind das über 100.000 Stringvergleiche pro Klick.
        // Eine Map löst dasselbe in konstanter Zeit. Das "erstes Vorkommen gewinnt"
        // Verhalten von indexOf bleibt durch die has()-Prüfung erhalten.
        if (!TMVariantPicker._sizeOrderIndex) {
          const sizeOrder = [...otherSizes, ...helmetSizes, ...clothingSizes];
          const index = new Map();

          sizeOrder.forEach((size, i) => {
            if (!index.has(size)) index.set(size, i);
          });

          TMVariantPicker._sizeOrderIndex = index;
          TMVariantPicker._sizeOrderLength = sizeOrder.length;
        }

        const sizeIndex = TMVariantPicker._sizeOrderIndex;
        const sizeOrderLength = TMVariantPicker._sizeOrderLength;    
      
        const { general, variants } = this.data;
        
        variants.sort((a, b) => {
            const indexA1 = sizeIndex.has(a.option1) ? sizeIndex.get(a.option1) : -1;
            const indexA2 = sizeIndex.has(a.option2) ? sizeIndex.get(a.option2) : -1;
            const indexB1 = sizeIndex.has(b.option1) ? sizeIndex.get(b.option1) : -1;
            const indexB2 = sizeIndex.has(b.option2) ? sizeIndex.get(b.option2) : -1;

            const indexA = indexA1 !== -1 ? indexA1 : (indexA2 !== -1 ? indexA2 : sizeOrderLength);
            const indexB = indexB1 !== -1 ? indexB1 : (indexB2 !== -1 ? indexB2 : sizeOrderLength);
        
            return indexA - indexB;
        });        

        const foundVariant = variants.find(v => v.id === id);
        if (!foundVariant) {
            console.warn(`Variant with ID ${id} not found`);
            return;
        }

        const optionsLookup = foundVariant.options.slice(0, -1);

        const optionNr = foundVariant.options.length === 2 ? 'option2' : 'option1';

        const foundColorVariants = variants.filter(v =>
            v.options.slice(0, -1).every((option, index) => option === optionsLookup[index])
        );

        if (!foundColorVariants.length) {
            console.warn(`No color variants found for options:`, optionsLookup);
            return;
        }

        // Alle Elemente erst in einem DocumentFragment sammeln und am Ende einmal
        // einhängen. Vorher wurde pro Variante zweimal direkt in den sichtbaren DOM
        // geschrieben - das löst bei jedem Schleifendurchlauf Layout-Arbeit aus.
        const fragment = document.createDocumentFragment();

        foundColorVariants.forEach(colorVariant => {
          let dotColor
          if (!colorVariant.status) {
            if (colorVariant.inventory_quantity > 0) {
              dotColor = "--available";       
            } else {
              dotColor = "--unavailable";
            }
          } else {
            dotColor = colorVariant.color;
          }

          let animationClass
          if (colorVariant.color == "--unavailable"){
             animationClass = "pulse_dot--no_animate";
          }

          const status = colorVariant.status
              ? colorVariant.status.replace(/, /g, " / ").replace(/ - /g, "-")
              : "";
          const value = colorVariant.options.slice(-1)[0];
          const formID = `${general.form_id}${optionNr}-${value.toLowerCase().replace(/ /g, "-")}`;

          const label = document.createElement('label');
          label.className = `picker2-swatch dropdown-swatch dropdown--swatch-new ${colorVariant.id === id ? "is-selected" : ""}`;
          label.setAttribute('for', formID);
          label.setAttribute('id', colorVariant.id);
          label.setAttribute('ean', colorVariant.ean);
          label.setAttribute('data-option-value', value);

          let bodySize = "";
          if (colorVariant.bodysize !== "") {
              bodySize = '<span class="break-after">Körpergröße </span>' + colorVariant.bodysize + '*';
          }
          
          label.innerHTML = `
              <div class="dropdown-swatch__info">
                  <span class="ll_variant_selected" style="font-size: var(--text-h6); line-height: var(--text-h6)">${value}</span>
                  <span>${bodySize}</span>
                  <span class="ll_last_variant_selected text-sm" style="color: var(${dotColor})">${status.replace('Auf Lager /', '<span class="break-after">Lieferzeit </span>').replace('Bald wieder ', '<span class="break-after">Bald wieder </span>').replace('<span class="break-after">Lieferzeit </span> 1-2 Werktage', 'Lieferung innerhalb 48 Stunden')}</span>
                  <div class="pulse_dot ${animationClass}" style="--dot-color: var(${dotColor})"></div>
              </div>
          `;

          const input = document.createElement('input');
          input.className = 'sr-only';
          input.type = 'radio';
          input.name = optionNr;
          input.id = formID;
          input.value = value;
          input.setAttribute('form', general.form);
          if (colorVariant.id === id) {
              input.checked = true;
          }

          fragment.appendChild(input);
          fragment.appendChild(label);
      });

      this.drawerSelector.appendChild(fragment);
    }
  }
}
window.customElements.define("variant-picker-tm", TMVariantPicker);

class WishlistButton extends HTMLButtonElement {
  constructor() {
    super();
    this.addEventListener('click', (e) => {
      this.toggleState(e);
    });
  }

  // Function to toggle the state
  toggleState(e) {

    let item = this;

    let product = {
      epi: parseInt(this.getAttribute('data-variant-id')),
      empi: parseInt(this.getAttribute('data-product-id')),
      du: parseInt(this.getAttribute('data-product-url'))
    }
  }
}

// Define the custom element 'wishlist-button' associated with the <button> tag
customElements.define('wishlist-button', WishlistButton, { extends: 'button' });


/*JSON Pickup Locations*/

class VariantLocations extends HTMLElement {
  constructor() {
    super();
    this.locations = JSON.parse(this.getAttribute('data-stocks'));

  }


  connectedCallback(){
    // .bind() erzeugt bei jedem Aufruf eine NEUE Funktion. Das frühere
    // removeEventListener(..., this.handleVariantChange.bind(this)) konnte den
    // Listener deshalb nie treffen - er blieb bei jedem Ein-/Aushängen bestehen
    // und sammelte sich an. Ein AbortController löst das zuverlässig.
    this._variantAbortController = new AbortController();

    document.addEventListener('variant:change', this.handleVariantChange.bind(this), {
      signal: this._variantAbortController.signal
    });
  }

  disconnectedCallback(){
    this._variantAbortController?.abort();
  }

  handleVariantChange(event){
      let variant = event.detail.variant;
      //this.locations.forEach((item) => console.log(Object.keys(item)[0]))
      let foundVariant = this.locations.find((item) => Object.keys(item)[0] === variant.id.toString());
      //console.log(foundVariant);
  }

}

document.addEventListener('DOMContentLoaded', function() {
    function getParameterByName(name) {
        const url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
        const results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    const searchQuery = getParameterByName('q');

    if (searchQuery) {
        const searchInput = document.getElementById('search-input');
        if (searchInput) {
            searchInput.placeholder = searchQuery;
        }
    }
});

customElements.define('variant-locations', VariantLocations);

function addClickListenerToPaymentButton() {
    const button = document.querySelector('.shopify-payment-button');

    if (button) {
      button.addEventListener('click', function() {       
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'dynamic_checkout_button_clicked',
        });
      });
    }
}



const shopify_payment_button_observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length) {
            addClickListenerToPaymentButton();
        }
    });
});

shopify_payment_button_observer.observe(document.body, {
    childList: true,
    subtree: true
});

function addClickListenerToFinanceButtons() {
    const buttons = document.querySelectorAll('financing-info[aria-controls="FinancingDrawer"]');
    buttons.forEach(button => {
        button.addEventListener('click', function() {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'event': 'pdp-financing_button_clicked',
          });
        });
    });
}
document.addEventListener('DOMContentLoaded', addClickListenerToFinanceButtons);

function addClickListenerToShippingButtons() {
    const buttons = document.querySelectorAll('span[aria-controls="ShippingInformationDrawer"]');
    buttons.forEach(button => {
        button.addEventListener('click', function() {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'event': 'pdp-shipping_button_clicked',
          });
        });
    });
}
document.addEventListener('DOMContentLoaded', addClickListenerToShippingButtons);

function addClickListenerToShippingEquipmentButtons() {
    const buttons = document.querySelectorAll('button[aria-controls="ShippingEquipmentDrawer"]');
    buttons.forEach(button => {
        button.addEventListener('click', function() {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'event': 'pdp-shipping_equipment_button_clicked',
          });
        });
    });
}
document.addEventListener('DOMContentLoaded', addClickListenerToShippingEquipmentButtons);

function addClickListenerToRefundButtons() {
    const buttons = document.querySelectorAll('button[aria-controls="RefundsInformationDrawer"]');
    buttons.forEach(button => {
        button.addEventListener('click', function() {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'event': 'pdp-refund_button_clicked',
          });
        });
    });
}
document.addEventListener('DOMContentLoaded', addClickListenerToRefundButtons);

function addClickListenerToNewsletterButtons() {
    const buttons = document.querySelectorAll('button[aria-controls="NewsletterInformationDrawer"]');
    buttons.forEach(button => {
        button.addEventListener('click', function() {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'event': 'pdp-newsletter_button_clicked',
          });
        });
    });
}
document.addEventListener('DOMContentLoaded', addClickListenerToNewsletterButtons);

function addClickListenerToLeasingButtons() {
    const buttons = document.querySelectorAll('button[aria-controls="LeasingDrawer"]');
    buttons.forEach(button => {
        button.addEventListener('click', function() {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'event': 'pdp-leasing_button_clicked',
          });
        });
    });
}
document.addEventListener('DOMContentLoaded', addClickListenerToLeasingButtons);

function addClickListenerToBestPriceButtons() {
    const buttons = document.querySelectorAll('button[aria-controls="BestPriceDrawer"]');
    buttons.forEach(button => {
        button.addEventListener('click', function() {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'event': 'pdp-best_price_button_clicked',
          });
        });
    });
}
document.addEventListener('DOMContentLoaded', addClickListenerToBestPriceButtons);

function addClickListenerToAufbauserviceButtons() {
    const buttons = document.querySelectorAll('button[aria-controls="AufbauserviceDrawer"]');
    buttons.forEach(button => {
        button.addEventListener('click', function() {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'event': 'pdp-aufbauservice_button_clicked',
          });
        });
    });
}
document.addEventListener('DOMContentLoaded', addClickListenerToAufbauserviceButtons);

function addClickListenerToSupportButtons() {
    const buttons = document.querySelectorAll('button[aria-controls="SupportDrawer"]');
    buttons.forEach(button => {
        button.addEventListener('click', function() {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'event': 'pdp-support_button_clicked',
          });
        });
    });
}
document.addEventListener('DOMContentLoaded', addClickListenerToSupportButtons);

document.addEventListener('DOMContentLoaded', function () {
    // Funktion, um ein Ereignis an den GTM zu senden
    function sendNavEventToGTM(href) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'navigationClick',
            eventCategory: 'Navigation',
            eventAction: 'Click',
            eventLabel: href
        });
    }
    const header = document.querySelector('.header');
    const navDrawer = document.querySelector('navigation-drawer');
    function monitorLinksInContainer(container) {
        if (container) {
            const navLinks = container.querySelectorAll('a');
            const spanLinks = container.querySelectorAll('span[data-href]');
            navLinks.forEach(function(link) {
                link.addEventListener('click', function(event) {
                    const href = link.getAttribute('href');
                    sendNavEventToGTM(href);
                });
            });
            spanLinks.forEach(function(span) {
                span.addEventListener('click', function(event) {
                    const href = span.getAttribute('data-href');
                    sendNavEventToGTM(href);
                });
            });
        }
    }
    monitorLinksInContainer(header);
    monitorLinksInContainer(navDrawer);
});

document.addEventListener('DOMContentLoaded', function () {
    function sendEventToGTM(eventLocation, eventCategory, href, currentUrl) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'ahrefClick',
            eventLocation: eventLocation,
            eventCategory: eventCategory,
            eventTarget: href,
            eventSource: currentUrl 
        });
    }
    document.body.addEventListener('click', function (event) {
        let link = event.target.closest('a[data-gtm-event]');
        if (!link) return;
        const gtmEvent = link.getAttribute('data-gtm-event');
        const href = link.getAttribute('href');
        const currentUrl = window.location.href;
        if (gtmEvent && href) {
            const [eventLocation, eventCategory] = gtmEvent.split('#');
            sendEventToGTM(eventLocation, eventCategory, href, currentUrl);
        }
    });
});

// Scroll-Position, ab der die Sticky-Funktion aktiviert wird
document.addEventListener('DOMContentLoaded', () => {
    const product_gallery = document.querySelector('.product-gallery');
    const artikelSection = document.querySelector('.shopify-section.shopify-section-artikel-dieser-kategorie');
    const mobileContainer = document.querySelector('.container_mobile.container');

    if (product_gallery && artikelSection && mobileContainer) {
        const artikelHeight = artikelSection.offsetHeight;
        const mobileContainerHeight = mobileContainer.offsetHeight;
        const startStickyScrollPosition = artikelHeight + mobileContainerHeight; 

        window.addEventListener('scroll', () => {
            const currentScroll = window.scrollY;

            if (currentScroll >= startStickyScrollPosition) {
                product_gallery.classList.add('sticky');
            } else {
                product_gallery.classList.remove('sticky');
            }
        });
    }
});

document.addEventListener('variant:change', (event) => {
  const drawers = document.querySelectorAll('x-drawer');
  drawers.forEach(drawer => {
      drawer.style.opacity = '0';
      drawer.style.visibility = 'hidden';
      drawer.removeAttribute('open');
  });
});

/* ----------------------------------------------------------------------------------------------------------------
   VORAUSWAHL "AUF LAGER" AUF KOLLEKTIONSSEITEN

   Zweiter Teil von snippets/ll-filter-preselect-in-stock.liquid (dort stehen Entscheidung, Pending-Dimmung und die
   ausfuehrliche Begruendung). Hier passieren zwei Dinge:

   1. Anwenden: wenn das Head-Snippet die Vorauswahl angefordert hat, wird der Lager-Filter ueber die vorhandene
      facet:update-Mechanik aus theme.js gesetzt. Das laedt nur den Collection-Abschnitt neu - danach kommt die
      Checkbox, der Filter-Chip, die Trefferzahl und die Paginierung serverseitig gerendert zurueck, also genau so,
      als haette der Kunde den Haken selbst gesetzt.

   2. Opt-out merken: jede Filter-Interaktion des Kunden laeuft durch facet:update - Haken in Sidebar und Drawer,
      das X am Filter-Chip, "Filter loeschen", Sortierung, Paginierung. Fehlt der Lager-Filter in der Ziel-URL,
      hat der Kunde ihn abgewaehlt und die Vorauswahl bleibt fuer diesen Tab aus; haekt er ihn wieder an, zaehlt das
      als Opt-in und die Vorauswahl greift in der naechsten Kollektion wieder.
      Der Listener haengt in der Capture-Phase, weil der Handler in theme.js auf document stopImmediatePropagation()
      aufruft und damit alles verschluckt, was in der Bubble-Phase danach kaeme.
---------------------------------------------------------------------------------------------------------------- */
(function () {
  const FILTER_PARAM = 'filter.v.availability';
  const IN_STOCK_VALUE = '1';

  /* Key und Klasse auch in snippets/ll-filter-preselect-in-stock.liquid - beim Aendern beide Stellen anfassen. */
  const OPT_OUT_KEY = 'll:in-stock-preselect-opt-out';
  const PENDING_CLASS = 'll-preselect-pending';

  const IN_STOCK_INPUT_SELECTOR = `input[name="${FILTER_PARAM}"][value="${IN_STOCK_VALUE}"]`;

  const readOptOut = () => {
    try {
      return sessionStorage.getItem(OPT_OUT_KEY) === '1';
    } catch (e) {
      return false;
    }
  };

  const writeOptOut = (optedOut) => {
    try {
      if (optedOut) {
        sessionStorage.setItem(OPT_OUT_KEY, '1');
      } else {
        sessionStorage.removeItem(OPT_OUT_KEY);
      }
    } catch (e) {
      /* Kein sessionStorage (Privatmodus, blockierte Storage) - dann gibt es kein Gedaechtnis, mehr nicht. */
    }
  };

  const clearPendingState = () => document.documentElement.classList.remove(PENDING_CLASS);

  document.addEventListener(
    'facet:update',
    (event) => {
      const url = event.detail && event.detail.url;

      if (!url) {
        return;
      }

      /* Nur auswerten, wenn die Seite den Lager-Filter ueberhaupt anbietet. Sonst wuerde jede andere
         Filteraktion auf einer Kollektion ohne diesen Filter als Abwahl gezaehlt werden. */
      if (!document.querySelector(IN_STOCK_INPUT_SELECTOR)) {
        return;
      }

      writeOptOut(!url.searchParams.getAll(FILTER_PARAM).includes(IN_STOCK_VALUE));
    },
    true
  );

  const applyInStockPreselect = () => {
    if (!window.llInStockPreselectRequested) {
      return;
    }

    /* Das Markup enthaelt zwei Facet-Formulare: den Drawer (mobil) und die Sidebar (Desktop, update-on-change).
       Beide liefern denselben Filter, die Sidebar wird bevorzugt, weil der Drawer sich beim Oeffnen zeitweise an
       <body> haengt (Drawer-Logik in theme.js) und damit nicht mehr im Abschnitt liegt. */
    const forms = Array.from(document.querySelectorAll('form[is="facet-form"]'));
    const form =
      forms.find((candidate) => candidate.hasAttribute('update-on-change') && candidate.querySelector(IN_STOCK_INPUT_SELECTOR)) ||
      forms.find((candidate) => candidate.querySelector(IN_STOCK_INPUT_SELECTOR));
    const checkbox = form ? form.querySelector(IN_STOCK_INPUT_SELECTOR) : null;
    const sectionId = form ? form.getAttribute('section-id') : null;
    const section = sectionId ? document.getElementById(`shopify-section-${sectionId}`) : null;

    /* Kein Filter im Markup (z.B. Filter in den Section-Settings deaktiviert), schon gesetzt, nicht waehlbar - oder
       das Opt-out kam erst nach dem Head-Snippet dazu. In allen Faellen nur aufdimmen und nichts anfassen. */
    if (!checkbox || checkbox.checked || checkbox.disabled || !form || !section || readOptOut()) {
      clearPendingState();
      return;
    }

    const url = new URL(window.location.href);

    url.searchParams.delete('page');
    url.searchParams.set(FILTER_PARAM, IN_STOCK_VALUE);
    url.searchParams.set('section_id', sectionId);

    /* Haken sofort in beiden Formularen (Sidebar und Drawer) setzen, damit die Filterspalte waehrend des Nachladens
       nicht im Widerspruch zur Liste steht. Das Server-HTML ueberschreibt das gleich sowieso. */
    document.querySelectorAll(IN_STOCK_INPUT_SELECTOR).forEach((input) => {
      input.checked = true;
    });

    /* Dimmung erst wegnehmen, wenn der Abschnitt tatsaechlich ersetzt ist (replaceChildren in theme.js), damit die
       ungefilterte Liste nie voll sichtbar wird. Timeout als Failsafe, falls der Request haengt oder fehlschlaegt. */
    const observer = new MutationObserver(() => {
      /* Der Handler in theme.js ersetzt die Kinder des Abschnitts und nimmt unmittelbar danach is-loading weg.
         Solange die Klasse noch steht, kam die Mutation von woanders (z.B. einer App) und ist nicht gemeint. */
      if (section.classList.contains('is-loading')) {
        return;
      }

      observer.disconnect();
      clearPendingState();
    });

    observer.observe(section, { childList: true });

    setTimeout(() => {
      observer.disconnect();
      clearPendingState();
    }, 4000);

    form.dispatchEvent(new CustomEvent('facet:update', { bubbles: true, detail: { url } }));
  };

  applyInStockPreselect();
})();
